import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Home2 from "./Home2";
import Type from "./Type";
import FadeIn from "../FadeIn";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <FadeIn direction="up">
                <h1 style={{ paddingBottom: 15 }} className="heading">
                  Hey There!{" "}
                  <span className="wave" role="img" aria-labelledby="wave">
                    👋🏻
                  </span>
                </h1>
              </FadeIn>

              <FadeIn direction="up" delay={0.1}>
                <h1 className="heading-name">
                  I'M
                  <strong className="main-name"> YASH KOPARKAR</strong>
                </h1>
              </FadeIn>

              <FadeIn direction="up" delay={0.2}>
                <div style={{ padding: 50, textAlign: "left" }}>
                  <Type />
                </div>
              </FadeIn>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <FadeIn direction="right">
                <img
                  src={homeLogo}
                  alt="home pic"
                  className="img-fluid"
                  style={{ maxHeight: "450px" }}
                />
              </FadeIn>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />

      <Container fluid className="home-section-find">
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <FadeIn direction="up">
              <h1>Find Me On</h1>
            </FadeIn>
            <FadeIn direction="up" delay={0.1}>
              <p>
                Feel free to <span className="purple">connect </span>with me
              </p>
            </FadeIn>
            <FadeIn direction="up" delay={0.2}>
              <p>
                <FaPhoneAlt />{" "}
                <a style={{ textDecoration: "none" }} className="purple" href="tel:+919373782519">
                  +91-9373782519
                </a>
              </p>

              <p>
                <AiOutlineMail />{" "} <a style={{ textDecoration: "none" }} className="purple" href="mailto:koparkaryash41@gmail.com">koparkaryash41@gmail.com</a>
              </p>

              <ul className="home-about-social-links">
                <li className="social-icons">
                  <a
                    href="https://github.com/Yashh0222"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/yash-koparkar-8307a128a/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.instagram.com/yash_koparkar_/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillInstagram />
                  </a>
                </li>
              </ul>
            </FadeIn>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;